import React, {Component} from 'react'
import posed from 'react-pose'
import Link, {push} from 'gatsby-link'
import Header from '../components/Header'
import logo from '../images/logo.png'
import symbol from '../images/symbol.svg'
import v1 from '../images/visual/01.jpg'
import v2 from '../images/visual/02.jpg'
import v3 from '../images/visual/03.jpg'
import v4 from '../images/visual/04.jpg'
import v5 from '../images/visual/05.jpg'
import v6 from '../images/visual/06.jpg'
import v7 from '../images/visual/07.jpg'

const Box = posed.div({
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
})

const status = {
  init: 'about',
  about: 'company',
  company: 'product',
  product: 'news',
  news: 'member',
  member: 'contact',
  contact: 'init'
}

const display = {
  about: 'About',
  company: 'Company',
  product: 'Product',
  news: 'News',
  member: 'Member',
  contact: 'Contact'
}

let id = -1
let timer = 0

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mouse: null,
      status: 'init',
      maxDeltaY: 0,
      scrollPosition: 0
    }
  }

  componentDidMount() {
    this.setTimer()
  }

  setTimer() {
    clearInterval(id)
    id = setInterval(() => this.setState({
      status: status[this.state.status]
    }), 5000)
  }

  onMouseEnter(target) {
    return () => {
      this.setState({
        mouse: target,
        status: target
      })
      clearInterval(id)
    }
  }

  onMouseLeave() {
    this.setState({
      mouse: null
    }, () => {
      setTimeout(() => this.setTimer(), 1000)
    })
  }

  onWheel(event) {
    if (window.innerWidth < 768) {
      return
    }
    clearTimeout(timer)
    const {deltaY} = event
    if (deltaY > 0) {
      if (deltaY > this.state.maxDeltaY) {
        this.setState({
          maxDeltaY: deltaY
        })
      }
    } else {
      if (this.state.maxDeltaY > deltaY) {
        this.setState({
          maxDeltaY: deltaY
        })
      }
    }
    timer = setTimeout(() => {
      if (this.state.maxDeltaY > 30) {
        this.setState({
          maxDeltaY: 0,
          scrollPosition: this.state.scrollPosition < 6 ? this.state.scrollPosition + 1 : this.state.scrollPosition
        })
      } else if (this.state.maxDeltaY < -30) {
        this.setState({
          maxDeltaY: 0,
          scrollPosition: this.state.scrollPosition >= 0 ? this.state.scrollPosition - 1 : this.state.scrollPosition
        })
      } else {
        this.setState({
          maxDeltaY: 0
        })
      }
    }, 500)
  }

  pose() {
    if (this.state.mouse !== null) {
      return this.state.mouse
    }
    if (this.state.scrollPosition === 0) {
      return this.state.mouse === null ? this.state.status : this.state.mouse
    } else {
      return [
        '',
        'about',
        'product',
        'member',
        'company',
        'news',
        'contact'
      ][this.state.scrollPosition]
    }
  }

  symbolPose() {
    if (this.state.scrollPosition !== 0) {
      return 'hidden'
    }
    return this.state.mouse === null ? 'visible' : 'hidden'
  }

  onClick() {
    switch (this.state.scrollPosition) {
      case 1: return push('/about')
      case 2: return push('/product')
      case 3: return push('/member')
      case 4: return push('/company')
      case 5: return push('/news')
      case 6: return push('/contact')
    }
  }

  render() {
    return (
      <div id="landing" onWheel={this.onWheel.bind(this)} onClick={this.onClick.bind(this)}>
        <Header isTop />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v2}")` }}
          pose={this.pose() === 'init' ? 'visible' : 'hidden'}
        />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v1}")` }}
          pose={this.pose() === 'about' ? 'visible' : 'hidden'}
        />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v3}")` }}
          pose={this.pose() === 'company' ? 'visible' : 'hidden'}
        />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v4}")` }}
          pose={this.pose() === 'product' ? 'visible' : 'hidden'}
        />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v5}")` }}
          pose={this.pose() === 'news' ? 'visible' : 'hidden'}
        />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v6}")` }}
          pose={this.pose() === 'member' ? 'visible' : 'hidden'}
        />
        <Box
          className="background"
          style={{ backgroundImage: `url("${v7}")` }}
          pose={this.pose() === 'contact' ? 'visible' : 'hidden'}
        />
        <Box className="symbol-container" pose={this.symbolPose()}>
          <div className="top" />
          <div className="left" />
          <div className="center"><img src={symbol} /></div>
          <div className="right" />
          <div className="bottom" />
        </Box>
        <Box className="title-container" pose={(this.state.mouse !== null || this.state.scrollPosition !== 0) ? 'visible' : 'hidden'}>
          <div className="top" />
          <div className="center">{display[this.pose()]}</div>
          <div className="bottom" />
        </Box>
        <h1 className="logo">
          <img src={logo} />
        </h1>
        <p className="message">Product for Peace</p>
        <ul className="landing-navigation">
          <li
            className="about"
            onMouseEnter={this.onMouseEnter('about')}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <Link to="/about">A</Link>
          </li>
          <li
            className="company"
            onMouseEnter={this.onMouseEnter('company')}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <Link to="/company">C</Link>
          </li>
          <li
            className="product"
            onMouseEnter={this.onMouseEnter('product')}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <Link to="/product">P</Link>
          </li>
          <li
            className="news"
            onMouseEnter={this.onMouseEnter('news')}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <Link to="/news">N</Link>
          </li>
          <li
            className="member"
            onMouseEnter={this.onMouseEnter('member')}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <Link to="/member">M</Link>
          </li>
          <li
            className="contact"
            onMouseEnter={this.onMouseEnter('contact')}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <Link to="/contact">C</Link>
          </li>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js